import { FC } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const AnalysticsIcon: FC<SvgIconProps> = (props) => (
	<SvgIcon {...props}>
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14.4444 2H3.55556C2.69645 2 2 2.69645 2 3.55556V14.4444C2 15.3036 2.69645 16 3.55556 16H14.4444C15.3036 16 16 15.3036 16 14.4444V3.55556C16 2.69645 15.3036 2 14.4444 2Z"
				stroke="currentColor"
				stroke-width="2"
				stroke-miterlimit="10"
			/>
			<path d="M9 4.5V13.5" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" />
			<path d="M12 6.75V13.5" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" />
			<path d="M6 8.25V13.5" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" />
		</svg>
	</SvgIcon>
);
